/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const DEFAULT_MUTATION_ERROR_MESSAGE = "Something went wrong. Please try again.";

const readFirstString = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  if (Array.isArray(value)) {
    for (const item of value) {
      const message = readFirstString(item);
      if (message) {
        return message;
      }
    }
    return null;
  }

  if (typeof value === "object") {
    for (const objectValue of Object.values(value)) {
      const message = readFirstString(objectValue);
      if (message) {
        return message;
      }
    }
  }

  return null;
};

export const getMutationErrorMessage = (
  error,
  fallbackMessage = DEFAULT_MUTATION_ERROR_MESSAGE
) => {
  const candidates = [
    error?.response?.data?.errors,
    error?.response?.data?.error,
    error?.message,
  ];

  for (const candidate of candidates) {
    const message = readFirstString(candidate);
    if (message) {
      return message;
    }
  }

  return fallbackMessage;
};

export { DEFAULT_MUTATION_ERROR_MESSAGE };
